var React = require('react');

function Play (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M54 0C24.2147 0 0 24.2147 0 54C0 83.7853 24.2147 108 54 108C83.7853 108 108 83.7853 108 54C108 24.2147 83.7853 0 54 0ZM71.3937 56.7284L45.9284 73.6674C43.7684 75.1453 40.8126 73.5537 40.8126 70.9389V37.061C40.8126 34.4463 43.7684 32.8547 45.9284 34.3326L71.3937 51.2716C73.3263 52.5221 73.3263 55.4779 71.3937 56.7284Z","fill":"white"}));
}

Play.defaultProps = {"width":"108","height":"108","viewBox":"0 0 108 108","fill":"none"};

module.exports = Play;

Play.default = Play;
